module.exports = __webpack_public_path__ + "img/3.0481dc28.png";